import { createApp } from 'vue'
import changepassword from './components/ChangePassword.vue'
import editprofile from './components/EditProfile.vue'

jQuery(function($) {
    if($("#app").length === 1) {
        createApp({
            components: {
                changepassword,
                editprofile
            },
            mounted() {
                console.log(`app started...`);
            }
        }).mount("#app");
    }
});
